import store, {types as storeTypes} from '../store'
import AlertModule from 'vux/src/plugins/alert/module'


export default function ($http) {
return {
initials(from) {
return $http
.get('/api/wx/account/init', {

from
})
.then(({data}) => {
store.commit(storeTypes.SET_USER, data.data);
return data.data
}).catch((response) => {//加个traycatch不然then报错执行不完整
console.log("")
})
},
homeInit() {
return $http
.get('/api/wx/account/init', {
handleError : false
})
.then(({data}) => {
store.commit(storeTypes.SET_USER, data.data);
console.log("plUser:", data.data);
return data.data
}).catch((response) => {//加个traycatch不然then报错执行不完整
console.log("")
})
}
}
}



// WEBPACK FOOTER //
// ./src/api/pt.js